import { render } from "./InteractiveGraphics.vue?vue&type=template&id=0157c487"
import script from "./InteractiveGraphics.vue?vue&type=script&lang=js"
export * from "./InteractiveGraphics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__